import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.css']
})
export class NewPasswordComponent implements OnInit {

  private email: string;
  private confirmCode: string;
  private password: string;
  private passwordConfirm: string;
  private error: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ) { 
    this.route.queryParams.subscribe(params=>{
      this.email = params['email'],
      this.confirmCode = params['code']
    })
  }

  ngOnInit() {
  }

  resetPassword(){
    if(this.password === this.passwordConfirm){
      this.userService.resetPassword(this.email,this.password,this.confirmCode)
      .then((res)=>{
        this.router.navigate(['login']);
        console.log(res)
      },(error)=>{
        this.error = error;
        console.log(error);
      })
    }else{
      this.error = 'Die Passwörter stimmen nicht überein';
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/guest/new-password/new-password.component.ts